var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTicketIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_595_1496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6156 6.17807L7.82193 0.384426C7.57578 0.138284 7.24195 1.82021e-06 6.89385 0H1.3125C0.587617 0 0 0.587617 0 1.3125V6.89385C1.82021e-06 7.24195 0.138284 7.57579 0.384426 7.82193L6.17807 13.6156C6.69063 14.1281 7.52166 14.1282 8.03422 13.6156L13.6156 8.03422C14.1281 7.52166 14.1281 6.69063 13.6156 6.17807ZM12.9969 7.41552L7.41552 12.9969C7.24481 13.1676 6.96776 13.1678 6.79681 12.9969L1.00313 7.20319C0.96238 7.16266 0.930071 7.11445 0.908077 7.06134C0.886083 7.00824 0.87484 6.9513 0.875 6.89382V1.3125C0.875 1.07127 1.07127 0.875 1.3125 0.875H6.89385C7.01072 0.875 7.12059 0.9205 7.20322 1.00313L12.9969 6.79678C13.1674 6.96738 13.1674 7.24495 12.9969 7.41552ZM3.9375 3.39062C4.23905 3.39062 4.48437 3.63595 4.48437 3.9375C4.48437 4.23905 4.23905 4.48438 3.9375 4.48438C3.63595 4.48438 3.39062 4.23905 3.39062 3.9375C3.39062 3.63595 3.63595 3.39062 3.9375 3.39062ZM3.9375 2.625C3.21262 2.625 2.625 3.21262 2.625 3.9375C2.625 4.66238 3.21262 5.25 3.9375 5.25C4.66238 5.25 5.25 4.66238 5.25 3.9375C5.25 3.21262 4.66238 2.625 3.9375 2.625Z",
    fill: "#6B6662"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_595_1496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketIcon);
export default __webpack_public_path__ + "static/media/ticket-icon.c36675eacc4f449f005d2fbfa4b37b08.svg";
export { ForwardRef as ReactComponent };